import { render, staticRenderFns } from "./CardStyle1Search.vue?vue&type=template&id=0a8a2b0e&scoped=true&"
import script from "./CardStyle1Search.vue?vue&type=script&lang=js&"
export * from "./CardStyle1Search.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle1Search.vue?vue&type=style&index=0&id=0a8a2b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a2b0e",
  null
  
)

export default component.exports